import { Modal, Box } from "@mui/material";

const modalContainerSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const modalContentSx = {
  backgroundColor: "background.paper",
  boxShadow: (theme) => theme.shadows?.[5] ?? "0px 2px 4px rgba(0, 0, 0, 0.2)",
  // MUI's FocusTrap auto-focuses this container (tabIndex=-1) when the modal opens.
  // With no outline reset, the browser draws its default focus ring (a blue box)
  // around the whole modal. Suppress it - the modal's own boxShadow already provides
  // a clear visual boundary, matching pre-uplift behavior.
  outline: "none",
};

function CustomModal({
  open,
  children,
  title,
  width = "24rem",
  borderRadius = "4px",
  padding = "16px 24px",
  titleClass = "",
  sx = {},
  onClose,
  containerClass = "",
}) {
  return (
    <Modal open={open} sx={modalContainerSx} onClose={onClose}>
      <Box
        className={containerClass}
        sx={{
          ...modalContentSx,
          width,
          borderRadius,
          padding,
          mx: { xs: "20px", sm: "auto" },
          ...sx,
        }}
      >
        <p className={`heading-h2-semibold ${titleClass}`}>{title}</p>
        {children}
      </Box>
    </Modal>
  );
}

export default CustomModal;
